/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface avatarFemaleProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const avatarFemale: React.SFC<avatarFemaleProps> = ({size, ...props}) => (
  <svg viewBox="0 0 60 60" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <g id="Layer_2">
      <path d="M60,30h0V0H0V30H0V60H60V30ZM35.71,47.5A11,11,0,0,1,30,48.89a11,11,0,0,1-5.71-1.4,22.75,22.75,0,0,0-10,5.64,28,28,0,1,1,31.5,0A22.75,22.75,0,0,0,35.71,47.5ZM53.9,11.87v0h0ZM44.63,3.8h0ZM13.26,5.1h0ZM5.88,12.16h0ZM6.09,48.1l.06.09,0,0Zm9.28,8.1-.08-.07.15.08Zm31.3-1.28.15-.1-.08.08Zm7.45-7.08-.07.06.08-.11ZM42.83,31.53a14.62,14.62,0,0,0,.36-3.2A11.81,11.81,0,0,0,37,18.07a7.63,7.63,0,0,0,.91-3.62,7.88,7.88,0,0,0-14.8-3.64c-1.36,2.47-1.44,4-4.49,4-.8-.07-1.29.74-.52,1.48a6.12,6.12,0,0,0,4,.92.69.69,0,0,1,.81.38.56.56,0,0,1-.23.69,11.72,11.72,0,0,0-5.79,10,14.62,14.62,0,0,0,.36,3.2,2.85,2.85,0,0,0,.22,5.63,2.83,2.83,0,0,0,1-.19C19.88,42.62,24.07,47.21,30,47.21s10.22-4.44,11.57-10.27a2.84,2.84,0,0,0,1.1.22,2.78,2.78,0,0,0,2.54-2.85A2.85,2.85,0,0,0,42.83,31.53Zm-8-14.64a14.5,14.5,0,0,0-3.37-.72,13.59,13.59,0,0,0-3.64.09c-.62.07-.67-.42-.34-.84a4.52,4.52,0,0,1,2.58-1.26,5.24,5.24,0,0,1,4.58,1.35C35.44,16.35,35.35,17,34.82,16.89Z"
        id="Layer_1-2" />
    </g>
  </svg>
);
avatarFemale.displayName = 'avatarFemale';
export default avatarFemale;
/* tslint:enable */
/* eslint-enable */
